import { SwipeDirection } from "@9amhealth/shared";
import { Blac } from "blac-next";
import { BriocheDismisserCubit } from "src/state/BriocheCubit/BriocheDismisserCubit";

export const dismissBrioche = (direction?: SwipeDirection) => {
  Blac.getBloc(BriocheDismisserCubit).dismissManually(direction);
};
